<!-- // Encabezado -->
<!-- *ngIf="isHandset$ | async"> -->
<mat-toolbar class="encabezado p-0">
  <div class="flecha-derecha"></div>
  <button type="button" aria-label="Toggle sidenav" mat-icon-button (click)="menuLatIzq.toggle()">
    <mat-icon class="txt-secundario-contraste" aria-label="Side nav toggle icon">menu</mat-icon>
  </button>
  <!-- #002554 -->
  <div class="h-100 ml-4" style="padding-top: 4px; background-color: #ffffff;">
    <img src="assets/img/Logo_de_Rotoplas.svg" alt="ROTOPLAS" height="52px">
    <!-- <img src="assets/img/IES-logo.svg" alt="IES" height="52px"> -->
    <!-- <img src="assets/img/bancobase-logo.svg" alt="IES" height="52px"> -->
  </div>
  <div class="flecha-derecha-second" ></div>
  <!-- #408fd2 -->
  <div class="w-100 h-100 d-flex align-items-center " style="background-color: #408fd2 ;">
    <p class="mb-0 ml-3 txt-secundario-contraste d-none d-md-block">
      {{tituloRespaldo}}
    </p>
    <p class="mb-0 ml-3 txt-secundario-contraste d-none d-md-block" style="font-size: 1px;">
      {{ ((datosRuta ? datosRuta.titulo : '') | formatStringRepseTitulo) == ''? tituloRespaldo: (datosRuta ? datosRuta.titulo : '') | formatStringRepseTitulo}}
      <span *ngIf="subtitulo">{{ (subtitulo | titlecase) | formatStringRepseTitulo}}</span>
    </p>
    <div class="ml-auto mr-3 d-flex align-items-center text-right" *ngIf="subsidiariaSeleccionada; else sinSubsidiaria">
      <mat-icon class="txt-secundario-contraste mr-2">apartment</mat-icon>
      <span class="txt-secundario-contraste font-weight-bold">
        SUBSIDIARIA: {{ subsidiariaSeleccionada | uppercase }}
      </span>
    </div>
    <ng-template #sinSubsidiaria>
      <div class="ml-auto mr-3 d-flex align-items-center text-right">
        <mat-icon class="txt-secundario-contraste mr-2">apartment</mat-icon>
        <span class="txt-secundario-contraste">
          Sin subsidiaria seleccionada
        </span>
      </div>
    </ng-template>
  </div>
</mat-toolbar>

<mat-sidenav-container class="layout-contenedor">
  <mat-sidenav #menuLatIzq class="menu-lat-izq" [fixedInViewport]="false"
      [attr.role]="(isHandset$ | async) ? 'dialog' : 'navigation'"
      [mode]="(isHandset$ | async) ? 'over' : 'side'"
      [opened]="(isHandset$ | async) === false">
    <div class="seccion-superior">
      <!-- Menú fijo de Subsidiarias -->
      <div class="mb-3 menu-opcion"
           [ngClass]="{'activo': datosRuta ? datosRuta.modulo === '/subsidiarias' : false}"
           routerLink="/subsidiarias">
        <mat-icon class="mb-0">work</mat-icon>
        <p class="sb-menu-titulo mb-0  ml-2">Subsidiarias</p>
      </div>
      <!-- Menús dinámicos -->
      <div class="mb-3 menu-opcion"
        [ngClass]="{'activo': datosRuta ? datosRuta.modulo === opt.ruta : false}"
        [routerLink]="opt.ruta" *ngFor="let opt of menuLateral">
        <mat-icon class="mb-0">{{opt.icono}}</mat-icon>
        <p class="sb-menu-titulo mb-0  ml-2">{{opt.titulo}}</p>
      </div>
      <ng-content select="[lateral-izquierdo]"> </ng-content>
    </div>
    <mat-nav-list class="seccion-inferior">
      <ng-container *ngFor="let conf of menuLatIzqInf">
        <div class="inferior-contenido" (click)="cerrarSesion()">
          <mat-icon class="icono-modulo">{{conf.icono}}</mat-icon>
          <span>&nbsp;&nbsp;</span>
          <span class="sb-menu-titulo nombre-modulo">{{conf.titulo}}</span>
        </div>
      </ng-container>
      <p class="text-center sb-version version mb-0">v {{version}}</p>
    </mat-nav-list>
  </mat-sidenav>
  <!-- // SIDEBAR SECUNDARIO -->
  <mat-sidenav class="menu-lat-der" [position]="'end'" #sideBarSecundario disableClose [mode]="(isHandset$ | async) ? 'over' : 'side'">
    <mat-toolbar class="text-right" style="height: 42px;">
        <div class="w-100 text-right">
            <button tabindex="-1" mat-icon-button (click)="cerrarSidebarSecundario()">
                <i class="fas fa-times" style="font-size: 18px;"></i>
            </button>
        </div>
    </mat-toolbar>
    <ng-content select="[sidebarLateral]"> </ng-content>
  </mat-sidenav>
  <mat-sidenav-content>
    <!-- Contenido -->
    <div class="contenido">
      <ng-content select="router-outlet"></ng-content>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
